module.exports = __webpack_public_path__ + "static/media/owner.ccb02402.svg";